var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('padding-full-customs',{attrs:{"config":_vm.padding,"default-value":{
      top: 13,
      bottom: 13,
      left: 40,
      right: 40
    }}}),_c('margin-full-customs',{staticClass:"mb-0",attrs:{"config":_vm.margin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }